module.exports = __webpack_public_path__ + "media/images/childcare/nassima@3x-0d0e8dadd2a2995a96ad3e4330ac01a2.jpg";